import { render, staticRenderFns } from "./QuestionsGrid.vue?vue&type=template&id=35d32cde&"
import script from "./QuestionsGrid.vue?vue&type=script&lang=js&"
export * from "./QuestionsGrid.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsGrid.vue?vue&type=style&index=0&id=35d32cde&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports